const headerNavLinks = [
  { href: '/articles', title: 'Articles' },
  { href: '/a-propos', title: 'À Propos' },
]

export default headerNavLinks
